export default "__VITE_ASSET__99470c00__"